import i18n from "i18next";

export const createValueString = (value) => {
  return value === 1 ? i18n.t("videoPlayer.defaultSpeed") : value.toString().replace(".", ",");
};
